import { ReactElement } from 'react';
import { ImgComparisonSlider } from '@img-comparison-slider/react';

import { StyledImageComparison } from './ImageComparison.styles';

import {GridWrapper } from '@theme/lib';
import Handle from "./handle.svg";

interface ImageProps {
  altText: string | null;
  url: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
}

export interface ImageComparisonProps {
  id: string;
  leftImage: ImageProps;
  rightImage: ImageProps;
}

export default function ImageComparison(data: ImageComparisonProps): ReactElement<any> {
  return (
    <GridWrapper alignment={'center'}>
      <StyledImageComparison>
        <ImgComparisonSlider>
          <img
            slot="first"
            src={data.leftImage.lg}
            alt={data.leftImage.altText || ''}
            width="100%"
            height="100%"
          />
          <img
            slot="second"
            src={data.rightImage.lg}
            alt={data.rightImage.altText || ''}
            width="100%"
            height="100%"
          />
          <Handle slot="handle" />
        </ImgComparisonSlider>
      </StyledImageComparison>
    </GridWrapper>
  );
}
